import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSave } from "@fortawesome/free-solid-svg-icons";
import ModalComponent from './../../../../components/common/ModalComponent';
import RichTextEditor from './../../../../components/common/RichTextEditor';
import { updateBusiness360Cell } from "../../../../service/ai-model.service";
import CustomLoader from "../../../../components/common/CustomLoader";
import { BusinessStatus } from "../../../../helper/constant";
import { useAppContext } from "../../../../context/app.context";

const EditBusinessCellModal = ({ id, name, showModal, setShowModal, data, onSave, reference, isStatus }) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { activeDashboardVersion } = useAppContext();

    useEffect(() => {
        setErrorMessage('');
    }, [showModal]);

    useEffect(() => {
        if (data) {
            setContent(data);
        }
    }, [data])

    const renderRitchEditor = () => {
        if (isStatus) {
            return (<div className="form-group d-flex flex-column">
                <label className="col-sm-5 col-form-label">{name}</label>
                <div className="col-sm-7 d-flex">
                    <div className="form-check form-check-inline text-nowrap">
                        <label className="mb-0 mr-1">
                            <input
                                className="form-check-input mr-0"
                                type="radio"
                                value={BusinessStatus.PENDING}
                                checked={content === BusinessStatus.PENDING}
                                onChange={(e) => setContent(e.target.value)}
                            />{" "}
                            {BusinessStatus.PENDING}
                        </label>
                    </div>
                    <div className="form-check form-check-inline text-nowrap">
                        <label className="mb-0 mr-1">
                            <input
                                className="form-check-input mr-0"
                                type="radio"
                                value={BusinessStatus.DONE}
                                checked={content === BusinessStatus.DONE}
                                onChange={(e) => setContent(e.target.value)}
                            />{" "}
                            {BusinessStatus.DONE}
                        </label>
                    </div>
                    <div className="form-check form-check-inline text-nowrap">
                        <label className="mb-0 mr-1">
                            <input
                                className="form-check-input mr-0"
                                type="radio"
                                value={BusinessStatus.ERROR}
                                checked={content === BusinessStatus.ERROR}
                                onChange={(e) => setContent(e.target.value)}
                            />{" "}
                            {BusinessStatus.ERROR}
                        </label>
                    </div>
                </div>
            </div>
            )
        }
        return (
            <>
                <div className="d-flex gap-2 justify-content-between align-items-start">
                    <div className="d-flex flex-column gap-2 flex-1">
                        <h6 className="text-xl mb-2">Editor</h6>
                        <RichTextEditor value={content} onChange={setContent} />
                    </div>
                    <div className="d-flex flex-column gap-2 flex-1">
                        <h6 className="font-bold mb-2">Output:</h6>
                        <div className="border p-2" dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </div>
            </>
        )
    }

    const onSavePressed = () => {
        if (content && reference) {
            let { pi, ri, oi, ti, ci, key } = reference;
            const query = new URLSearchParams(window.location.search);
            const payload = {
                companyName: query.get('org') || '',
                versionId: activeDashboardVersion,
                reference: {
                    products: pi,
                    opportunities: oi,
                    recommendations: ri,
                    sub_tasks: ti,
                    clients: ci,
                    key
                },
                content
            };
            setLoading(true);
            updateBusiness360Cell(payload)
                .then((res) => {
                    onSave && onSave(content);
                    setShowModal(false);
                })
                .catch((e) => {
                    setErrorMessage('Failed to update the cell. Please try again.');
                })
                .finally(() => setLoading(false));
        }
    }

    const renderAction = () => {
        return (
            <button className={`btn btn-primary align-self-end btn-success`} type="button" onClick={() => onSavePressed()} >
                <span><FontAwesomeIcon icon={faSave} /></span> Save
            </button>
        )
    }

    const renderContent = () => {

        return (
            <div className="ai-generative-data d-flex flex-column gap-1">
                {renderRitchEditor()}
            </div>
        )

    }

    const renderLoader = () => {
        if (loading) {
            return <div className="d-flex justify-content-center"><CustomLoader /></div>
        }
        if (errorMessage) {
            return <p className="text-danger text-center">{errorMessage}</p>
        }
    }

    const render = () => {
        return (
            <>
                {loading && <CustomLoader full />}
                <ModalComponent
                    full
                    title={name}
                    show={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                >
                    <div className="d-flex flex-column gap-2">
                        {renderAction()}
                        {renderLoader()}
                        {renderContent()}
                    </div>

                </ModalComponent>
            </>
        )
    }
    return render();
}
export default EditBusinessCellModal